module.exports = __webpack_public_path__ + "img/new_social_life.611222b7.png";